import { CommonModule } from '@angular/common';
import { Component, ElementRef, input, viewChild } from '@angular/core';
import { BaseConfig } from '../../common/config/config.adapter';

@Component({
  selector: '[modalContainer]',
  template: `
    <section [attr.data-theme]="theme()" #modal class="modal-container">
      <section class="rounded-t-[20px] overflow-hidden">
        <ng-content select="[header]" />
      </section>
      <section class="modal-content">
        <ng-content />
      </section>
      <section class="md:static fixed bottom-0 w-full rounded-b-[20px] overflow-hidden z-[9999] ">
        <ng-content select="[footer]" />
      </section>
    </section>
  `,
  imports: [CommonModule],
  styleUrls: ['./modal-container.component.scss'],
})
export class ModalContainer extends BaseConfig {
  modalRef = viewChild<ElementRef<HTMLElement>>('modal');

  ngAfterViewInit() {
    this.modalRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      },
    );
  }
}
